let _scrollRatio = 0;

export const scrollPositionStore = {
  get: () => _scrollRatio,
  save: (el: HTMLElement | null) => {
    if (!el) return;
    const max = el.scrollHeight - el.clientHeight;
    _scrollRatio = max > 0 ? el.scrollTop / max : 0;
  },
  restore: (el: HTMLElement | null) => {
    if (!el) return;
    const max = el.scrollHeight - el.clientHeight;
    if (max > 0) {
      el.scrollTop = _scrollRatio * max;
    }
  },
  reset: () => {
    _scrollRatio = 0;
  },
};
